import Loader from "components/shared/loader";
import React, { useEffect, useState } from "react";
import { getIntegrationSubscription, type IntegrationSubscription } from "sources/billing";
import IntegrationSubscriptionCard from "./integrationSubscription";
import LegacyBilling from "./legacy";

/** Resolve the billing provider before rendering provider-specific controls. */
export default function BillingTab(props: React.ComponentProps<typeof LegacyBilling>) {
    const [result, setResult] = useState<
        { status: "loading" } | { status: "error" } | { status: "ready"; subscription: IntegrationSubscription | null }
    >({ status: "loading" });
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        let active = true;
        getIntegrationSubscription().then(
            (subscription) => {
                if (active) {
                    setResult({ status: "ready", subscription });
                }
            },
            () => {
                if (active) {
                    setResult({ status: "error" });
                }
            },
        );
        return () => {
            active = false;
        };
    }, [attempt]);

    if (result.status === "loading") {
        return <Loader wrapCname="absolute-center" />;
    }
    if (result.status === "error") {
        return (
            <div className="alert alert-danger" role="alert">
                <p>Не удалось загрузить данные подписки.</p>
                <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    onClick={() => {
                        setResult({ status: "loading" });
                        setAttempt((value) => value + 1);
                    }}
                >
                    Повторить загрузку
                </button>
            </div>
        );
    }
    return result.subscription === null ? (
        <LegacyBilling {...props} />
    ) : (
        <IntegrationSubscriptionCard subscription={result.subscription} />
    );
}
